// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-E":"E_cost-saving-E__xs1UG"};